const columns = [
  {
    name: "Name",
    selector: (row) => row.name,
  },
  {
    name: "Action",
    selector: (row) => row.actions,
  },
];

export default columns;